import { Component, OnInit } from "@angular/core";
import { locale as italian } from "../../../../i18n/it";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { UtilsService } from "app/auth/service/utils.service";
import { HttpClient, HttpRequest } from "@angular/common/http";
import { Router } from "@angular/router";
import { environment } from "../../../../../environments/environment";
import moment from "moment";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-payroll-list",
  templateUrl: "./payroll-list.component.html",
  styleUrls: ["./payroll-list.component.scss"],
})
export class PayrollListComponent implements OnInit {
  public contentHeader: IContentHeader;

  public user_type_name: string = italian.data.MENU.PAYROLLS;

  public users: any = [];

  public files_list: any[] = [];

  public files_list_obj: any[] = [];

  public fiscalCodesNotFounded: string[] = [];

  public uploadErrors: any[] = [];

  public isUploaded: number = 0;

  public active_table: string = "";

  constructor(
    private _usersService: UserService,
    public _utilsService: UtilsService,
    private _httpClient: HttpClient,
    public _authenticationService: AuthenticationService,
    public _router: Router,
  ) {
    this.contentHeader = {
      headerTitle: this.user_type_name,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.MANAGE,
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: italian.data.MENU.PAYROLLS,
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("upload_payroll")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.users = await this._usersService.getList("employee", null, true, "hash,fiscal_code").then((result: any) => result.map((user: any) => user.fiscal_code || "").filter((fc: string) => fc.length > 0));
  }

  async addFileToList(files: any) {
    // creo una variabile dalla lista attuale
    let updatedList: any[] = this.files_list_obj.filter((item: any) => item.name !== "");
    // ciclo tutti i files inviati
    for (let file of files) {
      // riprendo il codice fiscale
      const fiscalCode: any = file.name.split("-")[0];
      // controllo se il codice fiscale esiste a sistema
      const fiscalCodeIsValid: any = this.users.includes(fiscalCode);
      // se non è valido vado lo inserisco in quelli non trovati ed esco
      if (!fiscalCodeIsValid) {
        this.fiscalCodesNotFounded.push(file.name);
        continue;
      }
      // controllo le dimensioni
      if (file.size > 10000000) {
        await this._utilsService.showSWALError({ text: "ERROR_MAX_FILE_SIZE" });
        continue;
      }
      // se esiste già nella lista lo tolgo
      const exists: any = updatedList.find((item: any) => item.name === file.name);
      // se esiste lo rimuovo
      if (exists) {
        updatedList = updatedList.find((item: any) => item.name === file.name);
      } else {
        // se non esiste lo metto nell'array dei files
        // aggiungo ai files
        this.files_list.push(file);
      }
      // aggiungo alla lista
      updatedList.push({
        name: file.name,
        size: this._utilsService.formatBytes(file.size),
        status: 0,
      });
    }
    // aggiorno variabile della pagina
    this.files_list_obj = updatedList;
  }

  resetFilesList() {
    this.files_list_obj = [];
    this.files_list = [];
  }

  removeFileFromList(index: any) {
    this.files_list_obj = this.files_list_obj.filter((item: any, i: number) => i !== index);
    this.files_list = this.files_list.filter((item: any, i: number) => i !== index);
  }

  async uploadFiles() {
    this.isUploaded = 1;
    // aspetto che tutti i file vengano processati
    Promise.all(
      this.files_list.map((file: File, index: number) => {
        const formData: FormData = new FormData();
        formData.append("file", file);

        const req: any = new HttpRequest("POST", `${environment.API_BASEURL}/upload/payroll`, formData);

        this.files_list_obj[index].status = 1;

        return this._httpClient
          .request(req)
          .toPromise()
          .then(() => {
            this.files_list_obj[index].status = 2;
          })
          .catch((err: any) => {
            this.files_list_obj[index].status = 3;
            this.uploadErrors.push({
              filename: this.files_list_obj[index].name,
              error: err.toUpperCase().replace(/\s/gi, "_"),
            });
          });
      }),
    ).then(async () => {
      // istanzio la variabile d'errore
      let error = false;
      //ciclo sull'array dei file
      for (const fileObj of this.files_list_obj) {
        //se trovo un file con status a 3 faccio partire l'errore
        if (fileObj.status === 3) {
          error = true;
          break;
        }
      }
      await this._utilsService.updateOption("last_payroll_update", moment().format("YYYY-MM-DD HH:mm:ss"), false);
      //se non ci sta nessun errore, carico la data di caricamento
      if (!error) {
        await this._utilsService.showSWALSuccess({ text: "SUCCESS_UPLOAD_FILES" });
      } else {
        // altrimenti no
        await this._utilsService.showSWALError({ text: "ERROR_UPLOAD_FILES" });
      }
    });
  }

  changeTab(tab: string) {
    this.active_table = this.active_table === tab ? "" : tab;
  }
}
